import { View } from "@react-pdf/renderer";
import { ResumePDFText } from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeEducation } from "lib/redux/types";
import {
  ResumePDFDescription,
  ResumePDFDescriptionWithWhiteFont,
  TemplateTwelvePDFSection,
  TemplateTwelvePDFSectionWithSubsections,
} from "./common";

export const Education = ({
  heading,
  educations,
  themeColor,
}: {
  heading: string;
  educations: ResumeEducation[];
  themeColor: string;
}) => {
  return (
    <TemplateTwelvePDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {educations.map(
        (
          { school, degree, startDate, endDate, gpa, descriptions = [] },
          idx
        ) => {
          // Hide school name if it is the same as the previous school
          const hideSchoolName =
            idx > 0 && school === educations[idx - 1].school;
          const showDescriptions = descriptions?.join() !== "";

          return (
            <View
              key={idx}
              style={{
                ...styles.flexCol,
                gap: spacing["1"],
                marginTop: spacing["0.5"],
              }}
            >
              {!hideSchoolName && (
                <ResumePDFText themeColor={themeColor} bold={true}>
                  {gpa ? `${degree} - ${gpa}` : degree}
                </ResumePDFText>
              )}
              <View style={{ ...styles.flexCol, gap: spacing["0.5"] }}>
                <ResumePDFText themeColor={themeColor}>{school}</ResumePDFText>
                <ResumePDFText themeColor={themeColor}>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              {showDescriptions && (
                <View style={{ ...styles.flexCol, marginTop: spacing["1.5"] }}>
                  <ResumePDFDescription
                    items={descriptions}
                    themeColor={themeColor}
                  />
                </View>
              )}
            </View>
          );
        }
      )}
    </TemplateTwelvePDFSectionWithSubsections>
  );
};
